<template>
  <div class="exam-list-page">
    <!-- 顶部区域 -->
    <div class="page-header">
      <div class="header-content">
        <h1 class="page-title">📝 在线考试</h1>
        <p class="page-subtitle">检验学习成果，获取专业认证</p>
      </div>
    </div>

    <!-- 考试列表 -->
    <div class="exam-container">
      <!-- 列表骨架屏 -->
      <div class="exam-skeleton-list" v-if="loading">
        <div class="exam-skeleton-card" v-for="i in 5" :key="i">
          <div class="skeleton-icon"></div>
          <div class="skeleton-content">
            <div class="skeleton-line skeleton-title-line"></div>
            <div class="skeleton-line skeleton-course-line"></div>
          </div>
          <div class="skeleton-status-area">
            <div class="skeleton-line skeleton-badge"></div>
          </div>
        </div>
      </div>

      <div class="exam-list" v-else-if="exam_list.length > 0">
        <div
          class="exam-card"
          v-for="(item, index) in exam_list"
          :key="index"
          :style="{ animationDelay: index * 0.08 + 's' }"
          @click="open_exam(item)"
        >
          <div class="exam-icon" :class="getStatusClass(item)">
            <span>{{ getStatusIcon(item) }}</span>
          </div>
          <div class="exam-content">
            <h4 class="exam-title">{{ item.Name }}</h4>
            <p class="exam-course">
              <span class="course-label">关联课程：</span>
              {{ item.CurriculumName }}
            </p>
          </div>
          <div class="exam-status">
            <span class="status-badge" :class="getStatusClass(item)">
              {{ item.ExamResult || '待考试' }}
            </span>
            <span class="exam-arrow">›</span>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="!loading && exam_list.length === 0" class="empty-state">
        <div class="empty-icon">📋</div>
        <p class="empty-text">暂无考试安排</p>
      </div>
    </div>

    <!-- 重新培训确认弹框 -->
    <van-dialog
      v-model="showRetrainConfirm"
      :show-confirm-button="false"
      :show-cancel-button="false"
      class="retrain-confirm-dialog"
    >
      <div class="confirm-dialog-content" v-if="retrainItem">
        <div class="confirm-dialog-thumb">
          <img :src="getThumb(retrainItem)" alt="" />
        </div>
        <div class="confirm-dialog-title">{{ retrainItem.CurriculumName }}</div>
        <div class="confirm-dialog-tip">考试未通过，需重新学习该课程后再次考试</div>
        <div class="confirm-dialog-actions">
          <button class="dialog-btn cancel" @click="showRetrainConfirm = false">取消</button>
          <button class="dialog-btn confirm" @click="goRetrain">前往学习</button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { WeChatMemberExam_MemberExamList } from '../api/api'

export default {
  name: 'examination_list',
  data() {
    return {
      exam_list: [],
      loading: true,
      showRetrainConfirm: false,
      retrainItem: null
    }
  },
  async mounted() {
    this.loading = true
    try {
      const { data } = await WeChatMemberExam_MemberExamList()
      this.exam_list = (data.response && data.response.data) || []
    } finally {
      this.loading = false
    }
  },
  methods: {
    getStatusIcon(item) {
      if (!item.ExamResult) return '📝'
      if (item.ExamResult.includes('通过') || item.ExamResult.includes('合格')) return '✅'
      return '❌'
    },
    getStatusClass(item) {
      if (!item.ExamResult) return 'status-pending'
      if (item.ExamResult.includes('通过') || item.ExamResult.includes('合格')) return 'status-pass'
      return 'status-fail'
    },
    open_exam(item) {
      if (!item.AllowAnswer) {
        // 弹出重新培训确认弹框
        this.retrainItem = item
        this.showRetrainConfirm = true
        return
      }
      this.$router.push({
        path: '/examination',
        query: item
      })
    },
    goRetrain() {
      if (!this.retrainItem || !this.retrainItem.CurriculumId) {
        this.$toast('无法获取课程信息')
        return
      }
      this.showRetrainConfirm = false
      this.$router.push({
        path: '/classStudy',
        query: { ids: this.retrainItem.CurriculumId, retrain: 1 }
      })
    },
    getThumb(item) {
      let thumb = item && item.CurriculumThumbnail || ''
      if (thumb && !thumb.startsWith('http')) {
        const baseUrl = 'https://share.51i.cc'
        thumb = baseUrl + (thumb.startsWith('/') ? '' : '/') + thumb
      }
      return thumb || require('../assets/logo.png')
    }
  }
}
</script>

<style scoped>
.exam-list-page {
  min-height: 100vh;
  background: #f5f9fc;
  /* 防止闪烁 - Android/iOS 兼容 */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-overflow-scrolling: touch;
}

/* 顶部区域 */
.page-header {
  background: #fff;
  padding: 20px 20px 10px;
  position: relative;
  overflow: hidden;
  text-align: center;
  border-bottom: 1px solid #f0f4f8;
}

.header-decoration, .deco-circle, .deco-circle-1, .deco-circle-2 {
  display: none;
}

.header-content {
  position: relative;
  z-index: 1;
}

.page-title {
  font-size: 20px;
  font-weight: 800;
  color: #1a2a3a;
  margin: 0 0 4px;
  letter-spacing: 0.5px;
}

.page-subtitle {
  font-size: 13px;
  color: #8a9aaa;
  margin: 0;
}

/* 考试容器 */
.exam-container {
  margin-top: 16px;
  padding: 0 16px 30px;
  position: relative;
  z-index: 10;
}

/* 考试列表 */
.exam-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 骨架屏样式 */
.exam-skeleton-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.exam-skeleton-card {
  display: flex;
  align-items: center;
  background: #ffffff;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.skeleton-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  margin-right: 14px;
  flex-shrink: 0;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

.skeleton-content {
  flex: 1;
  min-width: 0;
}

.skeleton-line {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
  border-radius: 4px;
}

.skeleton-title-line {
  height: 16px;
  width: 70%;
  margin-bottom: 10px;
}

.skeleton-course-line {
  height: 12px;
  width: 50%;
}

.skeleton-status-area {
  margin-left: 12px;
}

.skeleton-badge {
  height: 24px;
  width: 60px;
  border-radius: 12px;
}

@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.exam-card {
  display: flex;
  align-items: center;
  background: #ffffff;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  /* 防止闪烁 */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.exam-card:active {
  opacity: 0.9;
}

.exam-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  margin-right: 14px;
  flex-shrink: 0;
}

.exam-icon.status-pending {
  background: #fff5e6;
  color: #fa8c16;
}

.exam-icon.status-pass {
  background: #f6ffed;
  color: #52c41a;
}

.exam-icon.status-fail {
  background: #fff1f0;
  color: #f5222d;
}

.exam-content {
  flex: 1;
  min-width: 0;
}

.exam-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a2a3a;
  margin: 0 0 6px;
  line-height: 1.3;
}

.exam-course {
  font-size: 12px;
  color: #8a9aaa;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.course-label {
  color: #5a6a7a;
}

.exam-status {
  display: flex;
  align-items: center;
  margin-left: 12px;
}

.status-badge {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
  margin-right: 8px;
}

.status-badge.status-pending {
  background: rgba(255, 159, 67, 0.1);
  color: #ee5a24;
}

.status-badge.status-pass {
  background: rgba(38, 222, 129, 0.1);
  color: #20bf6b;
}

.status-badge.status-fail {
  background: rgba(252, 92, 101, 0.1);
  color: #eb3b5a;
}

.exam-arrow {
  font-size: 20px;
  color: #c0c8d0;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 14px;
  color: #8a9aaa;
  margin: 0;
}

/* 重新培训确认弹框 */
.retrain-confirm-dialog .van-dialog__header {
  display: none;
}

.confirm-dialog-content {
  padding: 20px 16px;
  text-align: center;
}

.confirm-dialog-thumb {
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 */
  border-radius: 12px;
  overflow: hidden;
  background: #f5f7fa;
  margin-bottom: 16px;
  position: relative;
}

.confirm-dialog-thumb img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.confirm-dialog-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a2a3a;
  margin-bottom: 8px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.confirm-dialog-tip {
  font-size: 14px;
  color: #8a9aaa;
  margin-bottom: 20px;
}

.confirm-dialog-actions {
  display: flex;
  gap: 12px;
}

.dialog-btn {
  flex: 1;
  height: 44px;
  border: none;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.dialog-btn:active {
  opacity: 0.8;
}

.dialog-btn.cancel {
  background: #f5f7fa;
  color: #666;
}

.dialog-btn.confirm {
  background: #d51900;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/examination_list.vue